// A Google Tag Manager tag injects part of its code as plain text straight into
// <body> (oaiq("measure", …) outside its <script>). The text renders as an
// extra line under the footer, which makes the page 20px taller than the
// layout and leaves a white strip above the fixed call button. React renders
// everything into #___gatsby, so text sitting directly in <body> is never ours.
const isStrayText = (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';

export const removeStrayBodyText = () => {
  if (typeof document === 'undefined' || !document.body) {
    return;
  }

  const sweep = () => {
    Array.from(document.body.childNodes)
      .filter(isStrayText)
      .forEach((node) => node.remove());
  };

  sweep();

  if (typeof MutationObserver !== 'undefined') {
    // Tags fire after load, so keep watching <body> itself (not its subtree).
    new MutationObserver(sweep).observe(document.body, { childList: true });
  }
};
